(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["phaze-card-gallery-enhancements"] && !Shopify.designMode) return;
  try {
    class PhazeCardQuickAdd extends HTMLElement {
    connectedCallback() {
      this.addEventListener('change', this.handleSizeChange);
    }

    disconnectedCallback() {
      this.removeEventListener('change', this.handleSizeChange);
    }

    handleSizeChange = (event) => {
      const input = event.target;
      if (!(input instanceof HTMLInputElement) || !input.matches('[data-phaze-size-option]')) return;

      const variantInput = this.querySelector('[data-phaze-variant-id]');
      const selectedSize = this.querySelector('[data-phaze-selected-size]');
      const addButton = this.querySelector('[data-phaze-add-button]');

      if (variantInput instanceof HTMLInputElement) {
        variantInput.value = input.value;
        variantInput.disabled = !input.value;
      }

      if (selectedSize) {
        selectedSize.textContent = input.dataset.sizeLabel || '';
      }

      if (addButton instanceof HTMLButtonElement) {
        addButton.disabled = input.disabled || input.dataset.available !== 'true' || !input.value;
      }
    };
  }

  if (!customElements.get('phaze-card-quick-add')) {
    customElements.define('phaze-card-quick-add', PhazeCardQuickAdd);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["phaze-fit-ui"] && !Shopify.designMode) return;
  try {
    (() => {
  if (customElements.get('phaze-fit-form')) return;
  let latestProductId = '';
  let submitting = false;
  const refreshAll = () => {
    document.querySelectorAll('phaze-fit-form').forEach(form => form.refresh());
    document.querySelectorAll('phaze-cart-matches').forEach(matches => matches.refresh());
  };
  document.addEventListener('cart:update', event => {
    if (!event.detail?.data?.didError && event.detail?.data?.productId) {
      latestProductId = String(event.detail.data.productId);
    }
    queueMicrotask(refreshAll);
  }, { capture: true });

  class PhazeFitPicker extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      this.addEventListener('change', () => this.refresh(), { signal: this.controller.signal });
      this.refresh();
    }
    disconnectedCallback() { this.controller?.abort(); }
    get variants() {
      try { return JSON.parse(this.querySelector('[data-pw-variants]')?.textContent || '[]'); }
      catch { return []; }
    }
    get input() {
      return this.querySelector('select[data-pw-variant], input[type="hidden"][data-pw-variant], input[data-pw-variant]:checked');
    }
    get selected() {
      const id = this.input?.value;
      return this.variants.find(variant => String(variant.id) === id);
    }
    selectVariant(id) {
      if (!this.variants.some(variant => String(variant.id) === String(id))) return;
      this.querySelectorAll('[data-pw-variant]').forEach(input => {
        if (input.type === 'radio') input.checked = input.value === String(id);
        else input.value = String(id);
      });
      this.refresh();
    }
    refresh() {
      const variant = this.selected || this.variants.find(item => item.available) || this.variants[0];
      const price = this.querySelector('[data-pw-price]');
      if (price && variant) price.textContent = variant.money;
      const choice = this.querySelector('[data-pw-choice]');
      if (choice && this.input?.dataset.label) choice.textContent = this.input.dataset.label;
    }
  }

  class PhazeCartMatches extends HTMLElement {
    connectedCallback() { this.refresh(); }
    refresh() {
      const forms = Array.from(this.querySelectorAll('phaze-fit-form'));
      const selected = forms.find(form => form.dataset.ownerId === latestProductId) || forms[0];
      forms.forEach(form => { form.hidden = form !== selected; });
      this.hidden = !selected;
    }
  }

  class PhazeFitForm extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.addEventListener('change', () => this.refresh(), { signal });
      this.addEventListener('submit', event => this.submit(event), { signal });
      if (this.dataset.mode === 'set') {
        document.addEventListener('variant:update', event => {
          if (String(event.detail?.data?.productId) !== this.dataset.productId) return;
          this.querySelector('phaze-fit-picker[data-primary="true"]')?.selectVariant(event.detail?.resource?.id);
          this.refresh();
        }, { signal });
      }
      this.refresh();
    }
    disconnectedCallback() { this.controller?.abort(); }
    get pickers() { return Array.from(this.querySelectorAll('phaze-fit-picker')); }
    refresh() {
      const pickers = this.pickers;
      const ready = pickers.length > 0 && pickers.every(picker => picker.selected?.available);
      const button = this.querySelector('[data-pw-add]');
      if (button) {
        button.disabled = submitting || !ready;
        button.setAttribute('aria-busy', this.busy ? 'true' : 'false');
      }
      const label = this.querySelector('[data-pw-button-label]');
      if (label) label.textContent = this.busy ? this.dataset.loading : ready ? this.dataset.ready : this.dataset.choose;
      const total = this.querySelector('[data-pw-total]');
      if (total) {
        const amount = pickers.reduce((sum, picker) => {
          picker.refresh();
          const variant = picker.selected || picker.variants.find(item => item.available) || picker.variants[0];
          return sum + (variant?.price || 0);
        }, 0);
        try {
          total.textContent = new Intl.NumberFormat(this.dataset.locale, {
            style: 'currency', currency: this.dataset.currency, currencyDisplay: 'code'
          }).format(amount / 100);
        } catch { total.textContent = (amount / 100).toFixed(2) + ' ' + this.dataset.currency; }
      }
    }
    async submit(event) {
      event.preventDefault();
      event.stopPropagation();
      if (submitting || !this.pickers.every(picker => picker.selected?.available)) return;
      const items = this.pickers.map(picker => ({ id: picker.selected.id, quantity: 1 }));
      const sourceId = this.querySelector('form')?.id || 'phaze-fit';
      const root = window.Shopify?.routes?.root || '/';
      const status = this.querySelector('[data-pw-status]');
      if (status) { status.textContent = ''; status.dataset.error = 'false'; }
      this.busy = true;
      submitting = true;
      refreshAll();
      let events;
      let added = false;
      try {
        events = await import('@theme/events');
        const sections = [...new Set(Array.from(document.querySelectorAll('cart-items-component'))
          .map(component => component.dataset.sectionId).filter(Boolean))].slice(0, 5);
        const response = await fetch(root + 'cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items, sections, sections_url: window.location.pathname })
        });
        const result = await response.json();
        if (!response.ok || result.status >= 400) {
          throw new Error(typeof result.description === 'string' ? result.description : this.dataset.error);
        }
        added = true;
        const cart = await fetch(root + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
          .then(response => response.ok ? response.json() : undefined).catch(() => undefined);
        document.dispatchEvent(new events.CartAddEvent(cart, sourceId, {
          source: 'phaze-fit',
          productId: this.dataset.productId,
          itemCount: items.length,
          sections: result.sections
        }));
        if (status && this.isConnected) status.textContent = this.dataset.added;
        if (!document.querySelector('cart-drawer-component')) window.location.assign(root + 'cart');
      } catch (error) {
        if (status && this.isConnected) {
          status.dataset.error = 'true';
          status.textContent = error.message || this.dataset.error;
        }
        if (events && !added) {
          const cart = await fetch(root + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
            .then(response => response.ok ? response.json() : undefined).catch(() => undefined);
          if (cart) document.dispatchEvent(new events.CartUpdateEvent(cart, sourceId, { source: 'phaze-fit', didError: true }));
        }
      } finally {
        submitting = false;
        this.busy = false;
        refreshAll();
      }
    }
  }
  customElements.define('phaze-fit-picker', PhazeFitPicker);
  customElements.define('phaze-cart-matches', PhazeCartMatches);
  customElements.define('phaze-fit-form', PhazeFitForm);
})();
  } catch(e) { console.error(e); }
})();

})();
